import { useCallback, useEffect, useRef } from 'react';

const useOutsideClick = (callback: () => void) => {
    const ref = useRef<HTMLDivElement | null>(null);

    const handleClickOutside = useCallback(
        (event: Event) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback();
            }
        },
        [callback]
    );

    useEffect(() => {
        const handleDocumentClick = (event: Event) => {
            handleClickOutside(event);
        };

        document.addEventListener('mousedown', handleDocumentClick);
        document.addEventListener('touchstart', handleDocumentClick);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
            document.removeEventListener('touchstart', handleDocumentClick);
        };
    }, [handleClickOutside]);

    return ref;
};

export default useOutsideClick;
